export default __webpack_public_path__ + "static/houses-db81d8e2a1c08d91779e24e5bd70b649.svg";